import { useCallback, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCommunicationList } from './useCommunicationList';

const TABS = ['ALL', 'WHATSAPP', 'SMS', 'CALL', 'EMAIL'];

interface UseCommunicationModalProps {
  initialTab?: string;
  onClose: () => void;
}

export const useCommunicationModal = ({
  initialTab = 'ALL',
  onClose,
}: UseCommunicationModalProps) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(initialTab);

  const {
    data,
    isLoading,
    isError,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useCommunicationList(activeTab);
  const communications = useMemo(
    () => (data?.pages ? data.pages.flatMap(page => page.list) : []),
    [data]
  );

  const tabCounts = data?.pages?.[0]?.tabCounts || {};

  const handleTabChange = useCallback((newValue: string) => {
    setActiveTab(newValue);
  }, []);

  const handleNavigate = useCallback(() => {
    onClose();
    navigate('/communication');
  }, [navigate, onClose]);

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);
  return {
    communications,
    tabCounts,
    error,
    isError,
    isLoading,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
    activeTab,
    setActiveTab: handleTabChange,
    handleNavigateToCommunications: handleNavigate,
    handleCloseModal: handleClose,
    markCommunication: () => {},
    tabs: TABS,
  };
}; 